import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import client from '../api/client';
import { CheckCircle, XCircle, Loader2, ArrowRight } from 'lucide-react';
import Logo from '../components/Logo';

const VerifyPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const [message, setMessage] = useState('Verificando tu cuenta...');
    const navigate = useNavigate();

    useEffect(() => {
        const verifyAccount = async () => {
            if (!token) {
                setStatus('error');
                setMessage('Token de verificación no encontrado.');
                return;
            }

            try {
                const response = await client.get(`/auth/verify?token=${token}`);
                setStatus('success');
                setMessage(response.data.message || '¡Cuenta verificada con éxito!');

                // Redirigir al login después de 3 segundos
                setTimeout(() => {
                    navigate('/login');
                }, 3000);
            } catch (err: any) {
                setStatus('error');
                setMessage(err.response?.data?.message || 'Error al verificar la cuenta. El enlace puede haber expirado.');
            }
        };

        verifyAccount();
    }, [token, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-[var(--bg-page)] p-6 relative overflow-hidden transition-colors duration-300">
            <div style={{ position: 'absolute', top: '10%', left: '5%', width: '300px', height: '300px', background: 'var(--primary)', filter: 'blur(150px)', opacity: 0.1, pointerEvents: 'none' }} />

            <div className="glass-card w-full max-w-[440px] p-8 md:p-12 flex flex-col gap-8 shadow-2xl transition-all duration-300 items-center text-center">
                <Logo size="large" />

                <div style={{ marginTop: '1rem' }}>
                    {status === 'loading' && (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
                            <Loader2 className="animate-spin" size={48} color="var(--primary)" />
                            <h2 style={{ fontSize: '1.5rem', fontWeight: 800 }}>{message}</h2>
                        </div>
                    )}

                    {status === 'success' && (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
                            <CheckCircle size={64} color="var(--success)" />
                            <h2 style={{ fontSize: '1.5rem', fontWeight: 800 }}>¡Todo listo!</h2>
                            <p style={{ color: 'var(--text-muted)' }}>{message}</p>
                            <p style={{ fontSize: '0.8rem', color: 'var(--text-dim)' }}>Redirigiendo al inicio de sesión...</p>
                            <Link to="/login" className="btn-primary" style={{ marginTop: '1rem', width: '100%', height: '48px' }}>
                                ENTRAR AHORA <ArrowRight size={20} />
                            </Link>
                        </div>
                    )}

                    {status === 'error' && (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
                            <XCircle size={64} color="var(--danger)" />
                            <h2 style={{ fontSize: '1.5rem', fontWeight: 800 }}>Ups... algo falló</h2>
                            <p style={{ color: 'var(--text-muted)' }}>{message}</p>
                            <Link to="/register" className="btn-secondary" style={{ marginTop: '1rem', width: '100%', height: '48px' }}>
                                VOLVER A REGISTRARSE
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VerifyPage;
